module.exports = __webpack_public_path__ + "img/XZ.d3893b45.png";